import { post, get, baseURL } from "@/utils/request";
import { i18n } from "@/i18n/index";

const { t } = i18n.global;

// Login
export const login = (data: any) => {
  return post(`/auth/login`, data).catch((err) => {
    if (err && err.code && err.code !== 200 && err.code !== 401) {
      const i18nKey = err.msg || 'common.error';
      return Promise.reject({
        handled: true,
        msg: t(i18nKey),
        code: err.code,
        i18nKey: err.i18nKey
      });
    }
    return Promise.reject(err);
  });
};

// Register
export const register = (data: any) => post(`/auth/register`, data);

// User info
export const getUserInfo = () => get(`/user/info`, {});

// PWA Reward API
export const PWARewardAPI = (data : any) => post(`/pwaReward/claim`, data);

// Add user favorites
export const addUserFavorites = (data: any) => post(`/favoriteGames/add`, data);

// Logout
export const logOut = () => post(`/auth/logout`);

//getCaptcha
export const getCaptchaCode = () => get(`/auth/code`);

//getsmsOTPCode
export const getSmsOtpCode = (param : any) => post(`/signIn/sendSmsCode?phoneNo=${param.phone}&areaCode=55`);

//getEmailOTPCode
export const getEmailOtpCode = (param : any) => post(`/signIn/sendEmailCode?email=${param.email}&login_account=${param.phone}`);

//getsmsOTPCode
export const getWhatsappOtpCode = (param : any) => post(`/signIn/sendWhatsAppCode?whatsAppNo=${param.phone}&areaCode=55`);

//fp check user exist
export const fpCheckUserExist = (data: any) => post(`/auth/fpCheckUserExist`, data);

//send otp
export const sendOtpCode = (data: any) => post(`/auth/forgetPw/sendOtp`, data);

//verify otp code
export const verifyOtpCode = (data: any) => post(`/auth/forgetPw/verifyOTP`, data);

//resetPassword
export const resetPassword = (data: any) => post(`/auth/resetPassword`, data);

